import { DashboardActionType } from './enums';

import { DashboardAction, DashboardState } from './interfaces';

export const initialState: DashboardState = {
	projectCosts: {},
	projectOverview: {},
	statusSummmary: {},
	projectsData: {},
	ticketsData: {},
	approvalsData: {},
	promoCodeHistory: [],
	promoCodeHistoryloading: true,
	totalRecords: 0,
	analyticsData: null,
	financialData: null,
	crmData: null,
	executiveData: null
};

export default (state = initialState, { type, payload }: DashboardAction): DashboardState => {
	switch (type) {
		case DashboardActionType.STORE_PROJECT_COSTS: {
			return {
				...state,
				projectCosts: payload
			};
		}

		case DashboardActionType.STORE_PROJECT_OVERVIEW: {
			return {
				...state,
				projectOverview: payload
			};
		}

		case DashboardActionType.STORE_STATUS_SUMMARY: {
			return {
				...state,
				statusSummmary: payload
			};
		}

		case DashboardActionType.STORE_DASHBOARD_PROJECTS: {
			return {
				...state,
				projectsData: payload
			};
		}

		case DashboardActionType.STORE_DASHBOARD_APPROVALS: {
			return {
				...state,
				approvalsData: payload
			};
		}

		case DashboardActionType.STORE_DASHBOARD_TICKETS: {
			return {
				...state,
				ticketsData: payload
			};
		}

		case DashboardActionType.STORE_PROMO_CODE_HISTORY: {
			const history = Array.isArray(payload) ? payload : payload?.history || [];

			return {
				...state,
				promoCodeHistory: history,
				promoCodeHistoryloading: false,
				totalRecords: history.length
			};
		}

		case DashboardActionType.STORE_ANALYTICS_DATA: {
			return { ...state, analyticsData: payload };
		}

		case DashboardActionType.STORE_FINANCIAL_DATA: {
			return { ...state, financialData: payload };
		}

		case DashboardActionType.STORE_CRM_DATA: {
			return { ...state, crmData: payload };
		}

		case DashboardActionType.STORE_EXECUTIVE_DATA: {
			return { ...state, executiveData: payload };
		}

		default: {
			return {
				...state
			};
		}
	}
};
